// Pages
import DomainSelectorPage from 'pages/DomainSelector';
import SignInMethodPage from 'pages/SignInMethod';
import StandardLoginPage from 'pages/StandardLogin';
import WorkEmailPage from 'pages/WorkEmail';
import PasswordResetPage from 'pages/PasswordReset';
import InviteTokenLandingPage from 'pages/InviteTokenLanding';
import MicrosoftSubscriptionPage from 'pages/Microsoft/MicrosoftSubscription';

export const DomainSelector = {
  path: '/domain/:redirectTo?',
  component: DomainSelectorPage,
  exact: true,
};

export const SignInMethod = {
  path: '/sign-in/:id/:redirectTo?',
  component: SignInMethodPage,
  exact: true,
};

export const StandardLogin = {
  path: '/standard/:id/:redirectTo?',
  component: StandardLoginPage,
  exact: true,
};

// Pearl TODO: replace this
export const WorkEmail = {
  path: ':redirectTo?',
  component: WorkEmailPage,
  exact: true,
};

export const PasswordReset = {
  path: '/:subdomain/resetpassword/:resetToken?',
  component: PasswordResetPage,
  exact: true,
};

export const InviteTokenLanding = {
  path: '/:subdomain/completeinvite/:inviteToken?',
  component: InviteTokenLandingPage,
  exact: true,
};

export const MicrosoftSubscription = {
  path: '/microsoft/confirm-subscription',
  component: MicrosoftSubscriptionPage,
  exact: true,
};

export default [
  DomainSelector,
  SignInMethod,
  StandardLogin,
  PasswordReset,
  InviteTokenLanding,
  MicrosoftSubscription,
];
